type TRange = {
  label: string;
  start: number;
  end: number;
};

export const FORMAT_LIMIT_MAP: Record<string, number> = {
  PDF: 500,
  CSV: 2000,
  JSON: 5000,
};

export const getMaxLimitByFormat = (documentFormat: {
  id: string;
  name: string;
}): number => {
  return FORMAT_LIMIT_MAP[documentFormat?.id?.toUpperCase()];
};

export const generateItemsRangeByFormat = (
  documentFormat: { id: string; name: string },
  totalRecords: number,
): TRange[] => {
  const limit = getMaxLimitByFormat(documentFormat);

  if (!limit || !totalRecords) return [];

  const ranges: TRange[] = [];
  let start = 1;

  while (start <= totalRecords) {
    const end = Math.min(start + limit - 1, totalRecords);
    ranges.push({
      label: `${start}-${end}`,
      start,
      end,
    });
    start = end + 1;
  }

  return ranges;
};
